<template>
  <Section title="The who, what and where" v-observe-visibility="intObseverCfg" pad-h pad-t>
    <SectionSubTitle>Orca Labs is a tech start-up founded autumn 2018 in Tromsø, Norway.</SectionSubTitle>
    <Paragraph class="scroll-reveal" size="medium">
      Our team of skilled software experts produces cutting edge distributed software spanning mobile apps to back-end
      cloud deployments. Key focus is on container-based application development and orchestration providing efficient
      software clustering, security, and deployment automation.
    </Paragraph>
    <Paragraph class="scroll-reveal" size="medium">
      We have strong ties to the academic and research communities in both Tromsø and Oslo.
    </Paragraph>
  </Section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'About',

  data() {
    return {
      intObseverCfg: {
        callback: this.setTopic,
        intersection: {
          rootMargin: '-200px',
        },
      },
    };
  },

  computed: mapState(['isScrolling']),

  methods: {
    setTopic: function (isVisible) {
      if (isVisible && !this.isScrolling) {
        this.$router.push({ path: '#about', query: { scroll: false } });
      }
    },
  },

  mounted() {
    this.$sr.reveal('.scroll-reveal', {
      distance: '160px',
      duration: 600,
      interval: 200,
      easing: 'cubic-bezier(0.23, 1, 0.32, 1)',
      viewOffset: { bottom: 200 },
    });
  },
};
</script>
